/* eslint-disable max-len */
export const osnArrowRightSmallIcon = {
  data: `<svg viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.9222 8.84167L14.8616 13.1751L10.9222 17.5085" stroke="white" stroke-width="1.27593" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'arrow-right-small',
};
